import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { AuthUserService } from '@services/auth-user.service';
import { isMobileApp } from '@functions/browser';
import { SlideMenuService } from '@services/slide-menu.service';
import { LayoutService } from '@components/layout/layout.service';
import { RouterDataService } from '@services/router-data.service';

import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-teacher-layout',
  templateUrl: './teacher-layout.component.html',
  styleUrls: ['./teacher-layout.component.scss'],
  standalone: false,
})
export class TeacherLayoutComponent implements OnInit, OnDestroy {
  authUserService = inject(AuthUserService);
  layoutService = inject(LayoutService);
  private slideMenuService = inject(SlideMenuService);
  routerDataService = inject(RouterDataService);

  isShowSidebar = true;
  sub: Subscription;

  ngOnInit() {
    this.sub = combineLatest([
      this.layoutService.isMediumDesktopDownView$,
      this.slideMenuService.slideStatus$,
      this.routerDataService.routerData$,
    ]).subscribe(([isMediumDesktopDownView, slideStatus, routerData]) => {
      if (!this.authUserService.isLoggedIn) {
        return;
      }

      if (isMediumDesktopDownView) {
        this.isShowSidebar = slideStatus === 'in';
      } else {
        this.isShowSidebar = routerData.isShowSidebar;
      }
    });
  }

  ngOnDestroy() {
    if (!!this.sub) {
      this.sub.unsubscribe();
      this.sub = null;
    }
  }

  get isMobileApp() {
    return isMobileApp();
  }
}
